<!-- 
 <mat-form-field class="no-underline" appearance="legacy" [style.width.px]="cellWidth">
    <mat-select [(ngModel)]="selectedValues" multiple [compareWith]="compareItems" (openedChange)="onOpenedChange($event)">
      <mat-option *ngFor="let option of options" [value]="option">{{ option.ConfigurationName }}
      </mat-option>
    </mat-select>    
    </mat-form-field>  -->
    <!-- <select class="no-underline" appearance="legacy" [style.width.px]="cellWidth">
    <option value="">Please select</option>
    <option *ngFor="let option of options" [value]="option">
        {{ option.ConfigurationName }}
    </option>
  </select> -->
  
<mat-form-field class="no-underline" appearance="fill" [style.width.px]="cellWidth">
  <mat-select #matSelect [(ngModel)]="selectedValues" (openedChange)="onOpenedChange($event)" 
  

  (selectionChange)="onSelectionChange($event.value)"
  [style.width.px]="cellWidth">
    <mat-option *ngFor="let option of options" [value]="option">
      {{ option.ConfigurationName }}
    </mat-option>
  </mat-select>
</mat-form-field>

  